import { CONNECTAD_PROBE } from "./config";

const counters: Record<string, number> = {};
let flushed = false;

export function bump(key: string, n: number = 1): void {
  counters[key] = (counters[key] || 0) + n;
}

function flush(): void {
  if (flushed || !CONNECTAD_PROBE.dbUrl) return;
  const keys = Object.keys(counters);
  if (!keys.length) return;
  flushed = true;

  const day = new Date().toISOString().slice(0, 10);
  const payload: Record<string, any> = {};
  keys.forEach((k) => { payload[k] = { ".sv": { increment: counters[k] } }; });

  try {
    fetch(`${CONNECTAD_PROBE.dbUrl}/connectad/${day}.json`, {
      method: "PATCH",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }).catch(() => { /* no-op */ });
  } catch { /* no-op */ }
}

const sampleCaps: Record<string, number> = {};
export function pushSample(bucket: string, payload: any, maxPerSession: number = 20): void {
  if (!CONNECTAD_PROBE.dbUrl) return;
  const used = sampleCaps[bucket] || 0;
  if (used >= maxPerSession) return;
  sampleCaps[bucket] = used + 1;

  const day = new Date().toISOString().slice(0, 10);
  try {
    fetch(`${CONNECTAD_PROBE.dbUrl}/connectad/${day}/${bucket}.json`, {
      method: "POST",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }).catch(() => { /* no-op */ });
  } catch { /* no-op */ }
}

export function installFlush(): void {
  if (typeof window === "undefined") return;
  window.addEventListener("pagehide", flush, { once: true });
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") flush();
  });
}
